export { default } from './MarcatgeEstructurat';
